import { render, staticRenderFns } from "./ListofProjects.vue?vue&type=template&id=5fb0b26c&scoped=true&"
import script from "./ListofProjects.vue?vue&type=script&lang=js&"
export * from "./ListofProjects.vue?vue&type=script&lang=js&"
import style0 from "./ListofProjects.vue?vue&type=style&index=0&id=5fb0b26c&scoped=true&lang=css&"
import style1 from "./ListofProjects.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0b26c",
  null
  
)

export default component.exports